"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var defaultProps = {
    children: null,
    sectionHeader: '',
};
var propTypes = {
    children: prop_types_1.default.node,
    sectionHeader: prop_types_1.default.string,
};
function SettingsPanelSection(props) {
    return (react_1.default.createElement(StyledPanelSectionContainer, null,
        react_1.default.createElement(StyledH4, null, props.sectionHeader),
        props.children));
}
exports.default = SettingsPanelSection;
SettingsPanelSection.defaultProps = defaultProps;
SettingsPanelSection.propTypes = propTypes;
/* istanbul ignore next */
var StyledPanelSectionContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 3.3rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  margin-left: 3.3rem;\n"])));
/* istanbul ignore next */
var StyledH4 = styled_components_1.default.h4(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  margin-top: 2.2rem;\n  margin-bottom: 2.4rem;\n  font-size: 1.8rem;\n  font-family: ", ";\n  font-weight: 500;\n  color: ", ";\n  line-height: 1.4rem;\n"], ["\n  margin-top: 2.2rem;\n  margin-bottom: 2.4rem;\n  font-size: 1.8rem;\n  font-family: ", ";\n  font-weight: 500;\n  color: ", ";\n  line-height: 1.4rem;\n"])), function (props) { return props.theme.fonts.robotoMedium; }, function (props) { return props.theme.colors.aqua[700]; });
var templateObject_1, templateObject_2;
